import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import _ from 'lodash'
import { Typography } from '@mui/material'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import { Column, Row } from 'src/components/Layout/Styled'
import { convertDateRange, convertFormatTime } from 'src/utils/lib'
import Detail from './Detail'

const Summary = () => {
  const data = useSelector((state) => state.classDetail.data, shallowEqual)
  const courseDetail = _.get(data, 'courseDetail', null)
  const trainingPlanData = _.get(data, 'trainingPlanData', null)
  const dateRange = convertDateRange(
    _.get(trainingPlanData, 'dateRangeMonthlyPlan', null)
  )
  const time = convertFormatTime(courseDetail)

  return (
    <Column sx={{ background: '#FAFAFA', mb: 2, p: 3, rowGap: 2 }}>
      <Row>
        <InsertInvitationIcon sx={{ mr: 1, fontSzie: 24, color: '#00008F' }} />
        <Typography variant="h6" color="primary.main">
          {`รายละเอียดเข้าอบรม`}
        </Typography>
      </Row>
      <Column sx={{ background: '#FFFFFF', p: 2, rowGap: '12px' }}>
        <Detail label={'วันที่อบรม'} value={dateRange} />
        <Detail label={'ระยะเวลาของหลักสูตร'} value={time} />
        <Detail
          label={'รูปแบบการสอน'}
          value={_.get(courseDetail, 'trainingPlatformName', '-')}
        />
        <Detail
          label={'กลุ่มหลักสูตร'}
          value={_.get(courseDetail, 'roadmap', '-')}
        />
      </Column>
    </Column>
  )
}

export default Summary
